var m = require('mithril');
var layout = require('../layout/layout');
var dashboard = require('./dashboards');
var homePage = require('./homePage');
var permissions = require('./permissions');

module.exports = {
  '/': {
    view: function() {
      return m(layout, m(dashboard));
    },
  },
  '/dashboard/:key': {
    view: function () {
      return m(layout, m(dashboard));
    }
  },
  '/dashboard/:id/permissions': {
    view: function () {
      return m(layout, m(permissions));
    }
  },
  '/home':{
    view: function () {
      return m(layout, m(homePage));
    }
  }
}
